(function () {
  const FORM_ID = 'product-form-template--19494343803105__product-form';

  function initRecipientFields() {
    const root = document.querySelector('.gift-fields');
    if (!root) return;

    const toggle = root.querySelector('#gift_toggle');
    const button = root.querySelector('.gift-button');
    const details = root.querySelector('#gift_details');
    const form = document.getElementById(FORM_ID) || root.closest('form');

    if (!toggle || !button || !details || !form) return;

    const BTN_DEFAULT = 'ADD YOUR MESSAGE HERE';
    const BTN_REMOVE = 'REMOVE MESSAGE';

    // One friendly error box
    let errorBox = root.querySelector('.gift-error');
    if (!errorBox) {
      errorBox = document.createElement('div');
      errorBox.className = 'gift-error';
      errorBox.setAttribute('role', 'alert');
      errorBox.style.display = 'none';
      errorBox.style.marginTop = '10px';
      errorBox.style.fontSize = '14px';
      errorBox.style.fontWeight = '600';
      root.appendChild(errorBox);
    }

    function hideError() {
      errorBox.style.display = 'none';
      errorBox.textContent = '';
    }

    function showError(msg) {
      errorBox.textContent = msg;
      errorBox.style.display = 'block';
    }

    // Hide theme/plugin generated spans like:
    // <span id="gift_to_phoneSubmit" class="required-field-error errors">undefined</span>
    function cleanupWeirdSubmitSpans() {
      const spans = root.querySelectorAll('span.required-field-error.errors[id$="Submit"]');
      spans.forEach((s) => {
        s.textContent = '';
        s.style.display = 'none';
      });
    }

    function hideDetails() {
      details.style.display = 'none';
      button.setAttribute('aria-expanded', 'false');
      button.textContent = BTN_DEFAULT;
    }

    function showDetails() {
      details.style.display = 'block';
      button.setAttribute('aria-expanded', 'true');
      button.textContent = BTN_REMOVE;
    }

    // Fields (match your current HTML)
    const fieldTo = details.querySelector('input[name="properties[Receiver name]"]');
    const fieldPhone = details.querySelector('input[name="properties[Your phone]"]') || details.querySelector('#gift_to_phone');
    const fieldFrom = details.querySelector('input[name="properties[From]"]');
    const fieldFromEmail = details.querySelector('#gift_from_email');
    const fieldMessage = details.querySelector('textarea[name="properties[Message]"]');

    const requiredFields = [
      fieldTo,
      fieldPhone,
      fieldFrom,
      fieldFromEmail,
      fieldMessage
    ].filter(Boolean);

    function setRequired(isRequired) {
      requiredFields.forEach((el) => {
        el.required = !!isRequired;
      });
    }

    function getFirstMissingField() {
      for (const el of requiredFields) {
        const val = (el.value || '').trim();
        if (!val) return el;
      }
      return null;
    }

    function updateUI() {
      hideError();
      cleanupWeirdSubmitSpans();

      if (toggle.checked) {
        showDetails();
        setRequired(true);
      } else {
        hideDetails();
        setRequired(false);
      }
    }

    // Button toggles checkbox (single source of truth)
    button.addEventListener('click', function () {
      toggle.checked = !toggle.checked;
      updateUI();

      if (toggle.checked && fieldTo) setTimeout(() => fieldTo.focus(), 0);
    });

    toggle.addEventListener('change', updateUI);

    // Clear errors as user types
    details.addEventListener('input', function () {
      hideError();
      cleanupWeirdSubmitSpans();
    });

    // Block Add to Cart with one friendly message
    // Do not call reportValidity/checkValidity to avoid theme error spans
    form.addEventListener('submit', function (e) {
      hideError();
      cleanupWeirdSubmitSpans();

      if (!toggle.checked) return;

      const missing = getFirstMissingField();
      if (missing) {
        e.preventDefault();
        showError('Please fill in all recipient and message details before adding to cart.');
        missing.focus();
        cleanupWeirdSubmitSpans();
      }
    });

    // Init
    cleanupWeirdSubmitSpans();
    toggle.checked = false; // ensure closed by default
    hideDetails();
    setRequired(false);
    updateUI(); // if pre checked somehow, opens and requires
  }

  document.addEventListener('DOMContentLoaded', initRecipientFields);
})();
